import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/pages/Login";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const { resetPassword } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (password !== confirm) { toast.error("Passwords do not match"); return; }
    setLoading(true);
    const res = await resetPassword(token, password);
    setLoading(false);
    if (res.ok) { setDone(true); setTimeout(() => navigate("/login"), 1800); }
    else toast.error(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-bone px-6" data-testid="reset-password-page">
      <div className="w-full max-w-md">
        <Link to="/" className="block"><img src="/logo.png" alt="In His Image Movement Ministries" className="h-24 w-auto object-contain mx-auto" /></Link>

        {!token ? (
          <div className="text-center mt-10" data-testid="reset-no-token">
            <h1 className="font-serif font-light text-4xl mt-8 tracking-tight">Invalid link.</h1>
            <p className="font-sans text-charcoal/60 mt-4">This reset link is missing its token.</p>
            <p className="font-sans text-sm text-charcoal/60 mt-8">
              <Link to="/forgot-password" className="text-olive border-b border-olive/40">Request a new link</Link>
            </p>
          </div>
        ) : done ? (
          <div className="text-center mt-10" data-testid="reset-success">
            <div className="inline-flex items-center justify-center w-16 h-16 border border-olive/30 bg-olive/10 rounded-full">
              <CheckCircle2 size={28} className="text-olive" strokeWidth={1.5} />
            </div>
            <h1 className="font-serif font-light text-4xl mt-8 tracking-tight">Password reset.</h1>
            <p className="font-sans text-charcoal/60 mt-4">Taking you to sign in…</p>
          </div>
        ) : (
          <>
            <h1 className="font-serif font-light text-4xl mt-10 tracking-tight text-center">Choose a new password.</h1>
            <p className="font-sans text-charcoal/60 mt-3 text-center">Enter and confirm your new password.</p>
            <form onSubmit={submit} className="space-y-6 mt-10">
              <Input label="New Password" type="password" value={password} onChange={setPassword} testid="reset-password" />
              <Input label="Confirm Password" type="password" value={confirm} onChange={setConfirm} testid="reset-confirm" />
              <button type="submit" disabled={loading} data-testid="reset-submit"
                className="group w-full bg-charcoal text-bone py-4 font-mono text-xs uppercase tracking-widest hover:bg-olive transition-colors flex items-center justify-center gap-3 disabled:opacity-50">
                {loading ? "Resetting..." : "Reset Password"} <ArrowRight size={16} className="hover-arrow" />
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
